import { Table } from '@mui/material';

import { globalTypes } from '@/shared/duck';

import { tableTypes } from '../../duck';
import { TableHeader, UITableBody } from './components';

const TableContent = <DataItem extends globalTypes.UIDItem>({
  columns,
  data,
  isStickyHeader = true,
  itemActions,
  loading,
  headerItemActions,
  ...props
}: tableTypes.MuiTableContentProps<DataItem>) => {
  return (
    <Table
      stickyHeader={isStickyHeader}
      aria-label='mui-table'
    >
      <TableHeader
        columns={columns}
        withEmptyItemActions={!headerItemActions && !!itemActions}
        headerItemActions={headerItemActions}
        itemSelection={props.itemSelection}
        {...props}
      />

      <UITableBody<DataItem>
        data={data}
        columns={columns}
        itemActions={itemActions}
        loading={loading}
        {...props}
      />
    </Table>
  )
}

export default TableContent;